import { useAppSelector } from '@/app/store';
import { ReactNode, FC, useEffect } from 'react';
import { ChainThemeEnum, ChainThemeStyle } from '@/app/store/api/restApi';

interface ThemeProviderProps {
  children: ReactNode;
}

export const ThemeProvider: FC<ThemeProviderProps> = ({ children }) => {
  const chainTheme = useAppSelector((state) => state.initial.settings.theme);

  useEffect(() => {
    document.documentElement.classList.remove(ChainThemeEnum.Dark, ChainThemeEnum.Light);
    if (chainTheme.name) document.documentElement.classList.add(chainTheme.name);
  }, [chainTheme.name]);

  useEffect(() => {
    document.body.classList.toggle('minimalistic-design', chainTheme.style === ChainThemeStyle.Minimalism);
  }, [chainTheme.style]);

  useEffect(() => {
    document.documentElement.style.setProperty('--primary', chainTheme.accentColor);
    document.documentElement.style.setProperty('--analog', chainTheme.analogColor);
    document.documentElement.style.setProperty('--secondary', chainTheme.firstColor);
    document.documentElement.style.setProperty('--accent', chainTheme.firstColor);
    document.documentElement.style.setProperty('--second', chainTheme.secondColor);
    document.documentElement.style.setProperty('--third', chainTheme.thirdColor);
  }, [
    chainTheme.accentColor,
    chainTheme.analogColor,
    chainTheme.firstColor,
    chainTheme.secondColor,
    chainTheme.thirdColor,
  ]);

  return <>{children}</>;
};
